import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=45b9c2c0&scoped=true"
import script from "./Upcoming.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upcoming.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=45b9c2c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b9c2c0",
  null
  
)

export default component.exports